module.exports = __webpack_public_path__ + "img/set_ac.fcc4442b.png";